import { FormProvider } from "react-hook-form";

import {
  useEmailForm,
  FormData as EmailFormData,
} from "../../hooks/useEmailForm";
import { Button } from "../atoms/Button";
import { InputWithLabel } from "../molecules/InputWithLabel";

import { Loading } from "./Loading";
import tw from "twin.macro";

interface Props {
  onSubmit: (data: EmailFormData) => void;
  inputLabel?: string;
  buttonLabel?: string;
  email?: string;
  className?: string;
}

export const EmailForm = ({
  onSubmit,
  buttonLabel,
  inputLabel,
  email,
  className,
}: Props) => {
  const { form, fields, disabled } = useEmailForm();

  return (
    <div tw="mt-2 w-full" className={className}>
      {email && (
        <section tw="mt-2">
          <h4 tw="font-base text-sm leading-[14px]">現在のメールアドレス</h4>
          <p tw="px-4 font-normal text-xs mt-3">{email}</p>
        </section>
      )}
      <FormProvider {...form}>
        <form css={email && tw`mt-8`} onSubmit={form.handleSubmit(onSubmit)}>
          <InputWithLabel
            {...fields.email}
            label={inputLabel ?? fields.email.label}
            type="email"
            placeholder="example@email.com"
            data-cy="email-input"
          />
          <Button
            tw="w-full bg-gradient-theme-to-l mt-8"
            type="submit"
            disabled={disabled}
            data-cy="email-submit-btn"
          >
            {buttonLabel}
          </Button>
        </form>
      </FormProvider>
      {form.formState.isSubmitting && <Loading />}
    </div>
  );
};
